// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.UpdatePatientQuickViewRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePatientQuickViewRequest extends GandalfModelBase {

	@GandalfLabel('Dominant Eye')
	@GandalfProperty({ designType: Number })
	dominantEyeId!: number | null;

	@GandalfLabel('Dominant Hand')
	@GandalfProperty({ designType: Number })
	dominantHandId!: number | null;

	@GandalfLabel('Drivers License')
	@GandalfValidator({ sizeString: { message: 'Drivers License cannot be longer than 20 characters', minLength: 0, maxLength: 20 } })
	@GandalfProperty({ designType: String })
	driversLicense!: string | null;

	@GandalfLabel('Employer Name')
	@GandalfValidator({ sizeString: { message: 'Employer Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	employerName!: string | null;

	@GandalfLabel('Patient Categories')
	@GandalfArray(Number)
	patientCategoryIds!: number[] | null;

	@GandalfLabel('General Notes')
	@GandalfValidator({ sizeString: { message: 'General Notes cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	patientComment!: string | null;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfLabel('Photo')
	@GandalfProperty({ designType: Number })
	photoId!: number | null;

	@GandalfLabel('Employment Position')
	@GandalfValidator({ sizeString: { message: 'Employment Position cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	position!: string | null;

	@GandalfConstantDecorator(constants.PatientEmploymentStatus)
	@GandalfLabel('Employment Status')
	@GandalfProperty({ designType: constants.PatientEmploymentStatus })
	status!: constants.PatientEmploymentStatus | null;

}
